import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchAllPublicIndicators } from "../../utils/api/liveFeedApi";
import { setMacroIndicators } from "../../store/actions/liveFeedActions";

const Ticker = () => {
  const dispatch = useDispatch();
  const localIndicators = useSelector(
    (state) => state.liveFeed.macroIndicators
  );

  useEffect(() => {
    const loadIndicators = async () => {
      try {
        const indicators = await fetchAllPublicIndicators();
        dispatch(setMacroIndicators(indicators));
      } catch (error) {
        console.error("Failed to load indicators:", error);
      }
    };

    if (localIndicators.length === 0) {
      loadIndicators();
    }
  }, [dispatch, localIndicators.length]);

  if (!localIndicators.length) {
    return null;
  }

  return (
    <div className="bg-dark text-white py-1 border-bottom border-secondary border-opacity-25">
      <marquee
        className="m-0 align-middle"
        style={{ fontSize: "12px", letterSpacing: "0.5px" }}
      >
        {localIndicators.map((indicator) => (
          <span key={indicator.uuid} className="me-4">
            <span className="text-white">{indicator.name}:</span>{" "}
            <strong style={{ color: "#0C9EA9" }}>
              {indicator.value || "N/A"}
            </strong>
          </span>
        ))}
      </marquee>
    </div>
  );
};

export default Ticker;
